(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lest-header-script"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-lest-header]').forEach((header) => {
    const desktopMegas = header.querySelectorAll('.lest-site-header__desktop-nav > .lest-site-header__mega');
    const headerBar = header.querySelector('.lest-site-header__bar');
    const syncHeaderState = () => {
      const hasOpenMega = Array.from(desktopMegas).some((mega) => mega.hasAttribute('open'));
      const isBarHovered = headerBar && headerBar.matches(':hover');
      header.classList.toggle('is-navigation-active', hasOpenMega || isBarHovered);
    };
    const closeAll = (exception) => {
      desktopMegas.forEach((mega) => {
        if (mega !== exception) mega.removeAttribute('open');
      });
    };

    desktopMegas.forEach((mega) => {
      let closeTimer;
      const openMega = () => {
        window.clearTimeout(closeTimer);
        closeAll(mega);
        mega.setAttribute('open', '');
        header.classList.add('is-navigation-active');
      };
      const closeMega = () => {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          mega.removeAttribute('open');
          syncHeaderState();
        }, 120);
      };

      mega.addEventListener('pointerenter', openMega);
      mega.addEventListener('pointerleave', closeMega);
      mega.addEventListener('focusin', openMega);
      mega.addEventListener('focusout', (event) => {
        if (!mega.contains(event.relatedTarget)) closeMega();
      });
      mega.querySelector('summary').addEventListener('click', (event) => {
        if (window.matchMedia('(min-width: 990px)').matches) event.preventDefault();
      });
      mega.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          mega.removeAttribute('open');
          syncHeaderState();
          mega.querySelector('summary').focus();
        }
      });
    });

    if (headerBar) {
      headerBar.addEventListener('pointerenter', () => header.classList.add('is-navigation-active'));
      headerBar.addEventListener('pointerleave', () => window.setTimeout(syncHeaderState, 130));
      headerBar.addEventListener('focusin', () => header.classList.add('is-navigation-active'));
      headerBar.addEventListener('focusout', () => window.setTimeout(syncHeaderState, 0));
    }
  });

  document.querySelectorAll('[data-lest-market-prompt]').forEach((prompt) => {
    const preferenceKey = 'lest_storefront_preference';
    const preferenceMaxAge = 30 * 24 * 60 * 60 * 1000;
    const params = new URLSearchParams(window.location.search);
    const forceCountry = params.get('lest_country');
    const stayInEnglish = params.get('stay') === 'en';
    const chinaLink = prompt.querySelector('[data-lest-market-china]');
    const dismissButtons = prompt.querySelectorAll('[data-lest-market-dismiss]');

    const savePreference = (value) => {
      try {
        window.localStorage.setItem(preferenceKey, JSON.stringify({
          value,
          expiresAt: Date.now() + preferenceMaxAge
        }));
      } catch (error) {
        document.cookie = `${preferenceKey}=${value}; Max-Age=2592000; Path=/; SameSite=Lax`;
      }
    };

    const readPreference = () => {
      try {
        const stored = JSON.parse(window.localStorage.getItem(preferenceKey));
        if (stored && stored.expiresAt > Date.now()) return stored.value;
        window.localStorage.removeItem(preferenceKey);
      } catch (error) {
        const match = document.cookie.match(new RegExp(`(?:^|; )${preferenceKey}=([^;]*)`));
        if (match) return decodeURIComponent(match[1]);
      }
      return null;
    };

    const hidePrompt = () => {
      prompt.hidden = true;
      document.documentElement.classList.remove('lest-market-prompt-visible');
    };

    const showPrompt = () => {
      prompt.hidden = false;
      document.documentElement.classList.add('lest-market-prompt-visible');
    };

    dismissButtons.forEach((button) => {
      button.addEventListener('click', () => {
        savePreference('en');
        hidePrompt();
      });
    });

    if (chinaLink) {
      chinaLink.addEventListener('click', () => savePreference('zh'));
    }

    if (stayInEnglish) {
      savePreference('en');
      hidePrompt();
      return;
    }

    if (window.Shopify && window.Shopify.designMode) return;

    if (forceCountry) {
      if (forceCountry.toUpperCase() === 'CN') showPrompt();
      return;
    }

    if (readPreference()) return;

    const root = window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';
    const currentCountry = window.Shopify && window.Shopify.country
      ? window.Shopify.country
      : '';
    const suggestionUrl = `${root}browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${encodeURIComponent(currentCountry)}`;

    window.fetch(suggestionUrl, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error('Localization suggestion unavailable');
        return response.json();
      })
      .then((data) => {
        const detectedCountry = data
          && data.detected_values
          && data.detected_values.country
          && data.detected_values.country.handle;
        if (detectedCountry === 'CN') showPrompt();
      })
      .catch(() => {
        /* The manual language switch remains available if GeoIP is unavailable. */
      });
  });
  } catch(e) { console.error(e); }
})();

})();
